import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { LightCache } from 'zf-web-components/widgets';
import { CONFIG } from 'config';
import { RootContext } from '@stores';
import { LogoutService } from '../services';
import type { LogoutHook } from './types';

export function useLogout(): LogoutHook {
  const navigate = useNavigate();
  const root = useContext(RootContext);

  const onLogout = async (): Promise<void> => {
    const { refreshToken, token } = root.local;
    await LightCache.clearAll();
    if (token == null || refreshToken == null) {
      navigate('/login');
      return;
    }
    await new LogoutService().logout({
      accessToken: token,
      refreshToken,
      baseURL: CONFIG.BACKEND_HOST
    });

    root.user = undefined;
    root.local.token = undefined;
    root.local.refreshToken = undefined;
    navigate('/login');
  };

  return {
    onLogout
  };
}
